import React from 'react'
import FooterWidgetComponent from '../../widgets/FooterWidget/FooterWidgetComponent'
import SavingsPlanBannerComponent from './widget/SavingsPlanBanner/SavingsPlanBannerComponent'
import SectionAComponent from './widget/SectionA/SectionAComponent'

function SavingPlan() {
  return (
    <div>
        <SavingsPlanBannerComponent/>
        <br/>
        <br/>
        <br/>
        <SectionAComponent/>
        <FooterWidgetComponent/>
    </div>
  )
}

export default SavingPlan